import React, { useEffect, useState } from "react";
import DataTable from 'react-data-table-component';
import { showSuccessToast } from "../../../utils/GlobalToast";
import { createDepartement, deleteDepartement, fetchAllDepartement, importDepartement, updateDepartement } from "../../../resources/DepartementResource";
import { format } from "date-fns";
import { getLocalAuth } from "../../../utils/AuthUtils";
import ErrorNotFound from "../../errors/Error";
import FormatDownload from "../../../components/format-download";

function Departement() {
    const values = getLocalAuth()
    const privilege = JSON.parse(values.authPrivilege);

    let dataPrivilege = privilege.data.menu.filter(data => {
        return data.code === "Department"
    });

    let dataRead = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
        return data.code === "Read"
    });

    let dataCreate = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
        return data.code === "Create"
    });

    let dataUpdate = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
        return data.code === "Update"
    });

    let dataDelete = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
        return data.code === "Delete"
    });

    let dataImport = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
        return data.code === "Import"
    });

    const [dataDepartement, setDataDepartement] = useState([]);
    const [name, setName] = useState("");

    const [idEdit, setIdEdit] = useState(null);
    const [nameEdit, setNameEdit] = useState("");

    const [isError, setIsError] = useState(false);
    const [error, setError] = useState("");
    const [isErrorImport, setIsErrorImport] = useState(false);
    const [errorImport, setErrorImport] = useState("");

    const [isLoading, setIsLoading] = useState(false);

    const [selectedFile, setSelectedFile] = useState(null);

    const [showAddModal, setShowAddModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showImportModal, setShowImportModal] = useState(false);

    const fetchDepartement = () => {
        fetchAllDepartement()
            .then((res) => {
                setDataDepartement(res.data);
            })
            .catch((err) => {
                setDataDepartement([]);
            });
    };

    useEffect(() => {
        fetchDepartement();

    }, []);

    const postImportDepartement = (selectedFile) => {
        setIsLoading(true);
        importDepartement(selectedFile).then((res) => {
            setIsLoading(false);
            setIsErrorImport(false);
            showSuccessToast("Success Import Departement!");
            setShowImportModal(false);
            fetchDepartement();
        }).catch((err) => {
            setIsLoading(false);
            setErrorImport(err);
            setIsErrorImport(true);
        });
    }

    const handleImport = (e) => {
        e.preventDefault();

        postImportDepartement(selectedFile);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        postDepartement(name);
    }

    const postDepartement = (name) => {
        setIsLoading(true);
        createDepartement(name).then((res) => {
            setIsLoading(false);
            setIsError(false);
            showSuccessToast("Success Added Departement!");
            setShowAddModal(false);
            setName("");
            fetchDepartement();
        }).catch((err) => {
            setIsLoading(false);
            setError(typeof err === 'undefined' ? 'There was an error checking your connection or input' : err);
            setIsError(true);
        });
    }

    const handleData = (data) => {
        setIdEdit(data.id);
        setNameEdit(data.name);
    }

    const handleDelete = () => {
        setIsLoading(true);
        deleteDepartement(idEdit).then((res) => {
            setIsError(false);
            showSuccessToast("Success Deleted Departement!");
            setShowDeleteModal(false);
            setIsLoading(false);
            fetchDepartement();
        }).catch((err) => {
            setError(typeof err === 'undefined' ? 'There was an error checking your connection or input' : err);
            setIsError(true);
            setIsLoading(false);
        });
    }

    const handleEdit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        updateDepartement(idEdit, nameEdit).then((res) => {
            setIsLoading(false);
            setIsError(false);
            showSuccessToast("Success Updated Departement!");
            setShowEditModal(false);
            fetchDepartement();
        }).catch((err) => {
            setIsLoading(false);
            setError(typeof err === 'undefined' ? 'There was an error checking your connection or input' : err);
            setIsError(true);
        });
    }

    const columns = [
        {
            name: 'No',
            cell: (row, index) => index + 1,
            width: '60px'
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Created At',
            selector: row => row.created_at === null ? '-' : format(row.created_at, "yyyy-MM-dd HH:mm").toString(),
            sortable: true,
        },
        {
            name: 'Updated At',
            selector: row => row.updated_at === null ? '-' : format(row.updated_at, "yyyy-MM-dd HH:mm").toString(),
            sortable: true,
        },
        {
            name: 'Actions',
            cell: row => (
                <>
                    {dataDelete.length === 0 ? <div></div> : !dataDelete[0].is_active ? <div></div> : <button type="button" style={{ marginRight: "8px" }} className="btn btn-danger" onClick={() => {
                        handleData(row);
                        setShowDeleteModal(true);
                    }}>Delete</button>}
                    <div className={`modal fade ${showDeleteModal ? 'show' : ''}`} style={{ display: showDeleteModal ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.1)' }}>
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Delete this data?</h5>
                                    <button type="button" className="btn-close" onClick={() => setShowDeleteModal(false)} aria-label="Close"></button>
                                </div>
                                {isError ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                                    <div className="alert alert-danger alert-dismissible fade show" role="alert">{error}
                                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsError(false)}></button>
                                    </div>
                                </div> : null}
                                <div className="modal-body">
                                    {`You will delete ${nameEdit}`}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>Cancel</button>
                                    {!isLoading ? <button type="submit" className="btn btn-danger" onClick={() => handleDelete()}>Delete</button> :
                                        <button className="btn btn-danger" type="button" disabled> <span style={{ marginRight: '4px' }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            Loading...</button>}
                                </div>
                            </div>
                        </div>
                    </div>
                    {dataUpdate.length === 0 ? <div></div> : !dataUpdate[0].is_active ? <div></div> : <button type="button" className="btn btn-info" onClick={() => {
                        handleData(row);
                        setShowEditModal(true);
                    }}>View</button>}
                    <div className={`modal fade ${showEditModal ? 'show' : ''}`} style={{ display: showEditModal ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.1)' }}>
                        <div className="modal-dialog modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Master Data Departement</h5>
                                    <button type="button" className="btn-close" onClick={() => setShowEditModal(false)} aria-label="Close"></button>
                                </div>
                                {isError ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                                    <div className="alert alert-danger alert-dismissible fade show" role="alert">{error}
                                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsError(false)}></button>
                                    </div>
                                </div> : null}
                                <div className="modal-body">
                                    <form onSubmit={handleEdit}>
                                        <div className="mb-3">
                                            <label className="form-label fw-bold">Name</label>
                                            <input required type="text" value={nameEdit} onChange={(e) => setNameEdit(e.target.value)} className="form-control" />
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-secondary" onClick={() => setShowEditModal(false)}>Cancel</button>
                                            {!isLoading ? <button type="submit" className="btn btn-info">Save</button> :
                                                <button className="btn btn-info" type="button" disabled> <span style={{ marginRight: '4px' }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    Loading...</button>}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </>

            ),
        },
    ];

    return (
        <div>
            {dataRead.length === 0 ? <ErrorNotFound /> : !dataRead[0].is_active ? <ErrorNotFound /> :
                <div className="page-content-wrapper">
                    <div className="page-content">
                        <div className="card">
                            <div className="card-body">
                                <div className="card-title">
                                    <div className="row">
                                        <div className="col">
                                            <h4 className="mb-0">Master Data Departement</h4>
                                        </div>
                                        <div className="col">
                                            <div className="text-end">
                                                {dataCreate.length === 0 ? <div></div> : !dataCreate[0].is_active ? <div></div> : <button type="button" className="btn btn-info ms-auto radius-10" onClick={() => {
                                                    setShowAddModal(true);
                                                }} style={{ marginRight: '8px' }}><i className='bx bx-plus'></i> Departement</button>}
                                                {dataImport.length === 0 ? <div></div> : !dataImport[0].is_active ? <div></div> : <button type="button" className="btn btn-success ms-auto radius-10" onClick={() => {
                                                    setShowImportModal(true);
                                                }}><i className='bx bx-import'></i> Import</button>}
                                            </div>
                                        </div>
                                        <div className={`modal fade ${showImportModal ? 'show' : ''}`} style={{ display: showImportModal ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                                            <div className="modal-dialog modal-dialog-scrollable">
                                                <div className="modal-content">
                                                    <div className="modal-header">
                                                        <h5 className="modal-title">Import Data Departement</h5>
                                                        <button type="button" className="btn-close" onClick={() => {
                                                            setShowImportModal(false);
                                                        }} aria-label="Close"></button>
                                                    </div>
                                                    {isErrorImport ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                                                        <div className="alert alert-danger alert-dismissible fade show" role="alert">{errorImport}
                                                            <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsErrorImport(false)}></button>
                                                        </div>
                                                    </div> : null}
                                                    <div className="modal-body">
                                                        <FormatDownload url={'/format-department.xlsx'} />
                                                        <form onSubmit={handleImport}>
                                                            <div className="mb-3">
                                                                <input required className="form-control" type="file" id="formFile" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={(e) =>
                                                                    setSelectedFile(e.target.files[0])
                                                                } />
                                                            </div>
                                                            <div className="modal-footer">
                                                                <button type="button" className="btn btn-secondary" onClick={() => {
                                                                    setShowImportModal(false);
                                                                }}>Cancel</button>
                                                                {!isLoading ? <button type="submit" className="btn btn-info">Submit</button> :
                                                                    <button className="btn btn-info" type="button" disabled> <span style={{ marginRight: '4px' }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                        Loading...</button>}
                                                            </div>
                                                        </form></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`modal fade ${showAddModal ? 'show' : ''}`} style={{ display: showAddModal ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                                            <div className="modal-dialog modal-dialog-scrollable">
                                                <div className="modal-content">
                                                    <div className="modal-header">
                                                        <h5 className="modal-title">Master Data Departement</h5>
                                                        <button type="button" className="btn-close" onClick={() => {
                                                            setShowAddModal(false);
                                                        }} aria-label="Close"></button>
                                                    </div>
                                                    {isError ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                                                        <div className="alert alert-danger alert-dismissible fade show" role="alert">{error}
                                                            <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsError(false)}></button>
                                                        </div>
                                                    </div> : null}
                                                    <div className="modal-body">
                                                        <form onSubmit={handleSubmit}>
                                                            <div className="mb-3">
                                                                <label className="form-label fw-bold">Name</label>
                                                                <input required type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} />
                                                            </div>
                                                            <div className="modal-footer">
                                                                <button type="button" className="btn btn-secondary" onClick={() => {
                                                                    setShowAddModal(false);
                                                                }}>Cancel</button>
                                                                {!isLoading ? <button type="submit" className="btn btn-info">Submit</button> :
                                                                    <button className="btn btn-info" type="button" disabled> <span style={{ marginRight: '4px' }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                        Loading...</button>}
                                                            </div>
                                                        </form></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="table-responsive">
                                    <DataTable
                                        columns={columns}
                                        data={dataDepartement}
                                        pagination
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

export default Departement;